<div class="d-flex flex-column ion-align-items-center ion-justify-content-center"
     (click)="action?.callback()">
    <div class="icon-circle-container d-flex ion-align-items-center flex-column ion-justify-content-center"
         [ngClass]="type">
        <div class="icon material-symbols-outlined">{{action.icon}}</div>
    </div>
    <div class="ion-text-center   font-weight-bold pt-xs" *ngIf="action.label">
        <span>{{action.label}}</span>
    </div>
</div>
